import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ArrearsDataTable from "./ArrearsDataTable";
import { closeArrearsModal, fetchArrears, openArrearsModal } from "./store/arrearsSlice";
import AddArrears from "./AddArrears";

const Arrears = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.arrearsData || {});

  useEffect(() => {
    dispatch(fetchArrears());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Arrear "
            title="Dashboard"
            subtitle="Arrear"
            name="Import Arrear"
            onAddClick={() => dispatch(openArrearsModal())}
          />

          <ArrearsDataTable data={data} loading={loading} />

          <AddArrears
            show={isModalOpen}
            onClose={() => dispatch(closeArrearsModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Arrears;
